<template>
  <div class="nlp__subscribe-bar-box">
    <div
      class="nlp__subscribe-bar-background"
      :class="{ 'nlp__subscribe-bar-background--error': isError }"
    >
      <div class="nlp__subscribe-bar-icon">
        <NlpSubscribeEmail />
      </div>
      <div class="nlp__subscribe-bar-input">
        <input
          v-model="email"
          class="nlp__subscribe-bar-input-field"
          placeholder="Enter your email"
          type="text"
          @focus="handleFocus"
        >
      </div>
      <div class="nlp__subscribe-bar-button">
        <NlpButton 
          :full-width="isNlpMobile"
          primary
          text="Subscribe"
          @button-click="sendEmailSubscribe"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import NlpSubscribeEmail from '@/pages/landing-page/svg/NlpSubscribeEmail.vue'
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'

// Vuex
import { mapActions } from 'vuex'

// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  name: 'NlpSubscribeBar',
  components: {
    NlpSubscribeEmail,
    NlpButton,
  },
  mixins: [deviceWidthMixin],
  data() {
    return {
      email: '',
      isError: false,
    }
  },
  methods: {
    ...mapActions('subscribe', ['emailSubscribe']),
    sendEmailSubscribe() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailPattern.test(this.email)) {
        this.isError = true
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Please enter a valid email address',
          life: 3000,
        })
      } else {
        this.emailSubscribe({
          email: this.email.toLowerCase()
        }).then(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'You have successfully subscribed',
            life: 3000,
          })
        })
      }
    },
    handleFocus() {
      this.isError = false
      this.email = ''
    },
  },
}
</script>

<style>
.nlp__subscribe-bar-box {
  width: 640px;
  position: relative;
}
.nlp__subscribe-bar-background {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 8px 0 24px;
  background-color: #fff;
  border: 1px solid #E2E9F6;
  border-radius: 30px;
  transition: background-color 0.3s ease, border 0.3s ease;
}
.nlp__subscribe-bar-background:hover {
  background-color: #F7F9FC;
  border: 1px solid #C3CBD9;
}
.nlp__subscribe-bar-background--error,
.nlp__subscribe-bar-background--error:hover {
  background-color: #FFFAFB;
  border: 1px solid #F1104E;
}
.nlp__subscribe-bar-input {
  flex: 1;
}
.nlp__subscribe-bar-input-field {
  width: 100%;
  height: 60px;
  padding: 0 12px;
  border: none;
  background-color: transparent;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: #5A627D;
}
.nlp__subscribe-bar-input-field:focus {
  outline: none;
  box-shadow: none;
}


@media (max-width: 767px) {
  .nlp__subscribe-bar-box {
    width: 100%;
    padding-bottom: 60px;
  }
  .nlp__subscribe-bar-background {
    max-width: 100%;
    height: 48px;
    padding: 0 0 0 16px;
  }
  .nlp__subscribe-bar-input-field {
    height: 48px;
    padding: 0 12px;
    font-size: 14px !important;
  }
  .nlp__subscribe-bar-button {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>